import { cn } from '@jk-core/utils';
import { CalendarView } from '@/Calendar/type';
import isSameDay from '@/Calendar/utils/isSameDay';
import styles from './MonthTile.module.scss';

const MONTHS = Array.from({ length: 12 }, (_, i) => i);

interface Props {
  selectedDate?: Date;
  viewDate: Date;
  handleMonthClick: (month: number) => void;
  tileContent?: (date: Date, view:CalendarView) => React.ReactNode;
  max: Date;
  min: Date;
}

export default function MonthTile({
  selectedDate, viewDate, handleMonthClick, tileContent = () => false,
  max, min,
}: Props) {
  const isDisabled = (month: number) => {
    const monthDate = new Date(viewDate.getFullYear(), month, 1);

    return monthDate > new Date(max.getFullYear(), max.getMonth(), 1)
      || monthDate < new Date(min.getFullYear(), min.getMonth(), 1);
  };

  return (
    <div className={styles['month-tile']}>
      {MONTHS.map((month) => (
        <button
          className={cn({
            [styles['month-tile__month']]: true,
            [styles['month-tile__month--selected']]: !!selectedDate && isSameDay(selectedDate, new Date(viewDate.getFullYear(), month), 'month'),
            [styles['month-tile__month--today']]: isSameDay(new Date(viewDate.getFullYear(), month), new Date(), 'month'),
            [styles['month-tile__month--tile']]: !!tileContent(new Date(viewDate.getFullYear(), month - 1, 1), 'month'),
          })}
          type="button"
          key={month}
          onClick={() => handleMonthClick(month)}
          disabled={isDisabled(month)}
        >
          <span>{`${month + 1}월`}</span>
          {!!tileContent(new Date(viewDate.getFullYear(), month - 1, 1), 'month')
            && tileContent(new Date(viewDate.getFullYear(), month - 1, 1), 'month')}
        </button>
      ))}
    </div>
  );
}
